import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../../lib/supabase'

export default function NextMatch() {
  const [fixture, setFixture] = useState(null)

  useEffect(() => {
    const fetchNextMatch = async () => {
      const now = new Date().toISOString()
      const { data } = await supabase
        .from('fixtures')
        .select('*')
        .eq('status', 'scheduled')
        .gte('match_date', now)
        .order('match_date', { ascending: true })
        .limit(1)
        .single()
      if (data) setFixture(data)
    }
    fetchNextMatch()
  }, [])

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">
        Next Match
      </div>
      {fixture ? (
        <div className="text-center py-4">
          <div className="text-2xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
            {fixture.home_team}
          </div>
          <div className="text-green-500 font-black text-3xl my-3">VS</div>
          <div className="text-2xl font-black uppercase tracking-tight mb-4 text-gray-900 dark:text-white">
            {fixture.away_team}
          </div>
          <div className="inline-block bg-green-100 dark:bg-green-900/30 border border-green-200 dark:border-green-800/50 text-green-600 dark:text-green-400 px-4 py-2 text-xs uppercase tracking-widest font-semibold mb-2">
            {new Date(fixture.match_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
            {' · '}
            {new Date(fixture.match_date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
          </div>
          <div className="text-gray-500 text-xs mt-1">{fixture.venue}</div>
        </div>
      ) : (
        <div className="text-gray-400 text-sm text-center py-8">No upcoming fixtures</div>
      )}
      <Link
        to="/fixtures"
        className="block text-center border border-gray-200 dark:border-white/10 hover:border-green-600 text-gray-500 dark:text-gray-400 hover:text-green-600 dark:hover:text-white py-3 text-xs font-bold uppercase tracking-widest transition-colors mt-6"
      >
        All Fixtures
      </Link>
    </div>
  )
}